import { outlineColors, outlines } from '../../common/outlines';
import { transitions } from '../../common/transitions';
import { colors, darkThemeSelector, shadows } from '../../stitches.config';

const selectorsParts = {
  disabled: '&[disabled=true], &:disabled',
  hover: '&:hover',
  focus: "&:focus-visible, &:has(:focus-visible), &[data-focus-visible='true']",
  focusWithin: '&:focus-within, &:has(:focus-within)',
};

export const selectors = {
  // States
  all: `&, ${selectorsParts.hover}, ${selectorsParts.focus}, ${selectorsParts.focusWithin}`,
  disabled: selectorsParts.disabled,
  focus: selectorsParts.focus,
  focusWithin: selectorsParts.focusWithin,
  hover: selectorsParts.hover,
  interactive: `${selectorsParts.hover}, ${selectorsParts.focus}, ${selectorsParts.focusWithin}`,

  // Content
  placeholder: '&::placeholder',

  // Browsers
  safari: `@supports (font: -apple-system-body) and (-webkit-appearance: none)`,
};

export { transitions };

export const labelColor = '$$labelColor';
export const iconColor = '$$iconColor';
export const markColor = '$$markColor';

export const raisedEnabledStyles = {
  [labelColor]: colors.gray600,
  [iconColor]: colors.gray500,
  [markColor]: colors.gray50,
  backgroundColor: colors.gray50,
  outline: outlines.control,
  outlineColor: outlineColors.control.raisedInitialLight,
  boxShadow: shadows.controlRaisedInitialLight,

  [selectors.hover]: {
    [labelColor]: colors.gray800,
    [iconColor]: colors.gray700,
    [markColor]: colors.gray50,
    backgroundColor: colors.white,
    outlineColor: outlineColors.control.raisedHoveredLight,
    boxShadow: shadows.controlRaisedHoveredLight,
  },

  [selectors.focus]: {
    outlineColor: outlineColors.control.raisedFocusedLight,
    boxShadow: shadows.controlRaisedFocusedLight,
  },

  [darkThemeSelector]: {
    [labelColor]: colors.gray50,
    [iconColor]: colors.gray100,
    [markColor]: colors.gray50,
    backgroundColor: colors.gray700,
    outlineColor: outlineColors.control.raisedInitialDark,
    boxShadow: shadows.controlRaisedInitialDark,

    [selectors.hover]: {
      [labelColor]: colors.white,
      [iconColor]: colors.gray50,
      [markColor]: colors.gray50,
      backgroundColor: colors.gray600,
      outlineColor: outlineColors.control.raisedHoveredDark,
      boxShadow: shadows.controlRaisedHoveredDark,
    },

    [selectors.focus]: {
      outlineColor: outlineColors.control.raisedFocusedDark,
      boxShadow: shadows.controlRaisedFocusedDark,
    },
  },
};

export const raisedDisabledStyles = {
  [labelColor]: colors.gray400,
  [iconColor]: colors.gray300,
  [markColor]: colors.gray300,
  outline: outlines.control,
  outlineColor: outlineColors.control.raisedDisabledLight,
  boxShadow: shadows.controlRaisedDisabledLight,

  [darkThemeSelector]: {
    [labelColor]: colors.gray200,
    [iconColor]: colors.gray300,
    [markColor]: colors.gray300,
    outlineColor: outlineColors.control.raisedDisabledDark,
    boxShadow: shadows.controlRaisedDisabledDark,
  },
};

export const raisedEnabledSelectedStyles = {
  [labelColor]: colors.brand50,
  [iconColor]: colors.brand100,
  [markColor]: colors.white,
  backgroundColor: colors.brand600,
  outline: outlines.control,
  outlineColor: outlineColors.control.raisedInitialLight,
  boxShadow: shadows.controlRaisedInitialLight,

  [darkThemeSelector]: {
    backgroundColor: colors.brand600,
    outlineColor: outlineColors.control.raisedInitialDark,
    boxShadow: shadows.controlRaisedInitialDark,
  },

  [selectors.hover]: {
    [labelColor]: colors.white,
    [iconColor]: colors.brand50,
    [markColor]: colors.brand50,
    backgroundColor: colors.brand700,
    outlineColor: outlineColors.control.raisedHoveredLight,
    boxShadow: shadows.controlRaisedHoveredLight,

    [darkThemeSelector]: {
      [selectors.hover]: {
        backgroundColor: colors.brand500,
        outlineColor: outlineColors.control.raisedHoveredDark,
        boxShadow: shadows.controlRaisedHoveredDark,
      },
    },
  },

  [selectors.focus]: {
    backgroundColor: colors.brand700,
    outlineColor: outlineColors.control.raisedFocusedLight,
    boxShadow: shadows.controlRaisedFocusedLight,

    [darkThemeSelector]: {
      [selectors.focus]: {
        backgroundColor: colors.brand500,
        outlineColor: outlineColors.control.raisedFocusedDark,
        boxShadow: shadows.controlRaisedFocusedDark,
      },
    },
  },
};

export const raisedDisabledSelectedStyles = {
  [labelColor]: colors.brand200,
  [iconColor]: colors.brand300,
  [markColor]: colors.brand200,
  backgroundColor: colors.brand600,
  outline: outlines.control,
  outlineColor: outlineColors.control.raisedDisabledLight,
  boxShadow: shadows.controlRaisedDisabledLight,

  [darkThemeSelector]: {
    [labelColor]: colors.brand300,
    [iconColor]: colors.brand400,
    [markColor]: colors.brand200,
    outlineColor: outlineColors.control.raisedDisabledDark,
    boxShadow: shadows.controlRaisedDisabledDark,
  },
};
